import React, { useContext, useEffect, useState } from 'react'
import './myUsage.scss'
import { LoaderContext } from '../../contexts/LoaderContext';
import { useNotification } from '../../contexts/NotificationContext';
import { getUserUsageRequest } from '../../webservices/webservice';
import { Icon } from '@mui/material';
import MainDatePicker from '../../components/dateTimePickers/mainDatePicker/MainDatePicker';
import { monthToShow } from '../../utils/date';
import moment from 'moment';


function MyUsage() {
  const [data, setData] = useState({});
  const [date,setDate] = useState(moment())
  const { showLoader, hideLoader } = useContext(LoaderContext)
  const notify = useNotification();

  const getUserUsage = (month,year) => {
    showLoader()
    getUserUsageRequest(month, year)
      .then(usageData => {
        hideLoader();
        setData(usageData)
      })
      .catch(error => {
        hideLoader()
        notify({
          type: "ERROR",
          message: error.message ? error.message : error,
          title: error.title ? error.title : "Error!!!"
        })
      })
  }

  const handleDateChange = (date) =>{
    if(date)
        {
            getUserUsage(date.month() +1 , date.year())
        }
        else{
            getUserUsage(null , null);
        }
  }


  useEffect(() => {
    getUserUsage(moment().month() +1 , moment().year());
    setDate(moment())
  }, [])

  return (
    <div className='myUsage'>
      <div className='head'>
        <div className='heading'>
          My Usage
        </div>
        <div className='drop-downs'>
          <MainDatePicker title={ 'Month and Year' } views={ [ 'year', 'month', ]} onChange={(e)=>{handleDateChange(e)}}  disableFuture value={date}/>
        </div>
      </div>

      <div className='mainContent'>
        {
          Object.keys(data).map((key, i) => (

            data[key].data ?
              (
                < div className='big-box' key={`userUsage${i}`}>
                  <div className='basic-info'>
                    <div className='body'>
                      <div className='heading'>
                        {key + (data[key]['isTotal'] ? " (Total)" : ` (${monthToShow(date)})` )}
                      </div>
                      <div className='total'>
                        {data[key].count}
                      </div>
                    </div>
                    <Icon className='icon' sx={{ color: `${data[key].color}` }}>
                      {data[key].icon}
                    </Icon>
                  </div>
                  <div className='data-grid'>
                    {
                      Object.keys(data[key].data).map((dataKey, j) => (
                        <div className='item' key={`userUsageData${j}`}>
                          <div className='label'>{dataKey}</div>
                          <div className='value'>{data[key].data[dataKey].count}</div>
                        </div>
                      ))
                    }
                  </div>
                </div>
              )
              :
              (
                <div className='small-box' key={`userUsage${i}`}>
                  <div className='body'>
                    <div className='heading'>
                    {key + (data[key]['isTotal'] ? " (Total)" : ` (${monthToShow(date)})` )}
                    </div>
                    <div className='total'>
                      {data[key].count}
                    </div>
                  </div>

                  <Icon className='icon' sx={{ color: `${data[key].color}` }}>
                    {data[key].icon}
                  </Icon>
                </div>
              )
          ))
        }





      </div>
    </div >
  )
}

export default MyUsage